<ng-container *t="let t">
    <div>
        <div>
            <div fxLayoutGap="10px">
                <div>
                    <div style="float: left;">
                        <p *ngIf="showManufacturingAddressCMTUrl">
                            <span i18n="@@200a43ccf0012e8a0b2ee053c8cf7a733d459452" t="200a43ccf0012e8a0b2ee053c8cf7a733d459452">To create a supplier change request
                                for any
                                Manufacturing
                                addresses please create a ticket in</span>

                            <a target="_blank" [href]="manufacturingAddresscmtUrl">CMT System.</a>
                        </p>
                    </div>
                    <div class="right">
                        <button tsl-button size="small" color="black" outline
                            *ngIf="this.userDetails && tabPermissions?.address != 'NoAccess' && filterSelection =='Manufacturing'"
                            (click)="showHistory();" i18n="@@efac3af0b32e953279c25b6519cae256811e0fe8" t="efac3af0b32e953279c25b6519cae256811e0fe8" 
                            tooltip="Show History" i18n-tooltip="@@2279638681844186468" #historyButton tslTooltip="{{ t('2279638681844186468', historyButton) }}">History</button>
                    </div>
                </div>
            </div>
            <!-- grid start -->
            <table tsl-table [dataSource]="currentPageSource" displayStripes="false">
                <ng-container tslColumnDef="address">
                    <th tsl-header-cell *tslHeaderCellDef class="columnwidth" i18n="@@e9ded9ddc67d3d863a5484c81550ee0de9b0ff04" t="e9ded9ddc67d3d863a5484c81550ee0de9b0ff04"> Address </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div class="address"
                            *ngIf="element.locationName || getFullAddress(element) || getFullAddressDetails(element) || getCountryDetails(element); else empty">

                            <span class="address_title"><b>{{element.locationName}}</b></span><br>
                            <span class="address_details">
                                {{getFullAddress(element)}}<br>
                                {{getFullAddressDetails(element)}}<br>
                                {{getCountryDetails(element)}}
                            </span>

                        </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="comment">
                    <th tsl-header-cell *tslHeaderCellDef class="comments" i18n="@@a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee" t="a3d57cb09b8c89d3e10ceaf70f53ad0d454144ee"> Comment </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element.comment.newValue; else empty">{{ element.comment.newValue }} </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="documents">
                    <th tsl-header-cell *tslHeaderCellDef class="documents" i18n="@@627a946d2acf02d81b1a7edcacd987bb8e8d1814" t="627a946d2acf02d81b1a7edcacd987bb8e8d1814"> Documents </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div>

                        </div>
                    </td>
                </ng-container>

                <ng-container tslColumnDef="actions">
                    <th tsl-header-cell *tslHeaderCellDef class="actions icons" i18n="@@030b4423b92167200e39519599f9b863b4f7c62c" t="030b4423b92167200e39519599f9b863b4f7c62c">Actions</th>
                    <td tsl-cell *tslCellDef="let element" class="actions icons">
                        <ng-container>

                        </ng-container>
                    </td>
                </ng-container>

                <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
                <tr tsl-row *tslRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Group header -->
                <ng-container tslColumnDef="groupHeader">
                    <td colspan="5" tsl-cell *tslCellDef="let group">
                        <strong class="group-header"> {{ translateService.get(group.name) }}</strong>
                    </td>
                </ng-container>
                <tr tsl-row *tslRowDef="let row; columns: ['groupHeader']; when: isAddressHeader"> </tr>
            </table>
            <!-- grid end -->
            <ng-template #empty>
                <tsl-icon>maximize</tsl-icon>
            </ng-template>
            <!-- grid pagination -->
            <tsl-pagination showFirstLastButtons [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
                (pageChange)="pageChange($event)" [itemsPerPageLabel]="translateService.get('ItemsPerPage')" [total]="total"></tsl-pagination>
        </div>


    </div>
</ng-container>